import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { useCommissionsActiveSteps } from 'shared/widgets/CommissionsTabs/hooks/useCommissionsActiveSteps';
import { Commission } from 'types/embedded/commission';

import { CommissionsTabsActiveStep } from './CommissionsTabsActiveStep';

export const CommissionsShowActiveSteps: React.FC = () => {
  const record = useRecordContext<Commission>();
  const { data: activeSteps } = useCommissionsActiveSteps(record?.ladder?.id);

  return (
    <Box display="grid" gap={3} gridTemplateColumns="repeat(3, 1fr)">
      {activeSteps?.map((step) => (
        <RecordContextProvider key={step.id} value={step}>
          <CommissionsTabsActiveStep />
        </RecordContextProvider>
      ))}
    </Box>
  );
};
